






































































import BaseComponent from '@/components/base-component.vue';
import { IndicadBolsasMedicoFiltrosDTO } from '@/interfaces/crm-institution';
import { listInstitutionChartPrescrDoctors } from '@/services/crm-institution';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    // Solução para referencia recursiva:
    InstitutionForm: () => import('./institution-form.vue')
  }
})
export default class InstitutionPrescrDoctorsCharts extends BaseComponent {
  @Prop()
  id: number;

  items = [];
  res: any = {};
  loading = false;

  itemSelec = null;
  showMenu = false;
  menuX = 0;
  menuY = 0;

  monthOptions = [
    { id: 6, label: '6 meses' },
    { id: 12, label: '12 meses' }
  ];

  months = 6;
  multi = null;

  institutionFormOpen = false;
  idInstitutionSelected = null;

  mounted() {}

  public headers: any = [];

  @Watch('id', { immediate: true })
  onIdChange(id) {
    if (!id) {
      return;
    }
    this.load();
  }

  tableKey = 1;

  load() {
    let f = new IndicadBolsasMedicoFiltrosDTO();
    f.idInstituicao = this.id;
    f.meses = this.months;
    f.bolsaMulti = this.multi;
    this.loading = true;
    listInstitutionChartPrescrDoctors(f).subscribe(
      (res) => {
        this.res = res;
        this.buildHeaders(res);
        this.items = res;
        this.loading = false;
        this.tableKey++;
      },
      (error) => {
        this.showToastApiError(error);
        this.loading = false;
      }
    );
  }

  buildHeaders(res) {
    this.headers = new Array();
    let h = this.headers;
    h.push({ text: 'Médico', value: 'nmMedico', sortable: true });
    if (!res.length) {
      return;
    }
    res[0].meses.forEach((m, index) => {
      h.push({
        text: m.descricao,
        value: 'meses[' + index + '].valor',
        sortable: true,
        align: 'right'
      });
    });
  }

  showOthersInstitutions(item, e) {
    this.showMenu = false;
    this.itemSelec = item;
    this.menuX = e.clientX + 20;
    this.menuY = e.clientY;
    this.itemSelec.key = Math.random();
    setTimeout(() => {
      this.showMenu = true;
    }, 50);
  }

  showInstitution(id) {
    this.idInstitutionSelected = id;
    this.institutionFormOpen = true;
  }

  closeInstitutionForm() {
    this.institutionFormOpen = false;
    this.idInstitutionSelected = null;
  }
}
